import { Banknote, CalendarDays, CreditCard, Percent, Truck } from 'lucide-react';
import type { ProposalPayment } from '@/api/commercial/proposals';
import {
  fmtCents,
  InfoMiniCard,
} from '@/components/commercial/proposals/shared/summary-components';
import type { ICartPaymentSummary } from '@/types/commercial/cart';

interface ResumeNegotiationInfoCardProps {
  payment: ProposalPayment | null;
  paymentSummary: ICartPaymentSummary | null;
}

export function ResumeNegotiationInfoCard({
  payment,
  paymentSummary,
}: ResumeNegotiationInfoCardProps) {
  if (!payment) {
    return <p className="px-1 text-sm text-muted-foreground">Pagamento não configurado</p>;
  }

  const isCash = payment.paymentType === 'CASH';
  const freightInCents = paymentSummary?.shippingInCents ?? payment.freteInCents ?? 0;

  const cards = [
    <InfoMiniCard
      key="type"
      icon={<Banknote className="h-5 w-5 text-emerald-600" />}
      label="Tipo de venda"
      value={isCash ? 'À vista' : 'A prazo'}
    />,
  ];

  if (!isCash) {
    if (payment.dueDay > 0) {
      cards.push(
        <InfoMiniCard
          key="due"
          icon={<CalendarDays className="h-5 w-5 text-cyan-600" />}
          label="Vencimento"
          value={`Dia ${payment.dueDay}`}
        />,
      );
    }
    cards.push(
      <InfoMiniCard
        key="installments"
        icon={<CreditCard className="h-5 w-5 text-violet-600" />}
        label="Parcelamento"
        value={`${payment.installments}x`}
      />,
    );
    if (payment.hasDownPayment && payment.downPaymentPercentage) {
      cards.push(
        <InfoMiniCard
          key="entrance"
          icon={<Percent className="h-5 w-5 text-amber-600" />}
          label="Entrada"
          value={`${payment.downPaymentPercentage}%`}
        />,
      );
    }
  }

  cards.push(
    <InfoMiniCard
      key="freight"
      icon={<Truck className="h-5 w-5 text-orange-600" />}
      label="Frete"
      value={fmtCents(freightInCents)}
    />,
  );

  return (
    <div className="grid min-w-0 grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {cards}
    </div>
  );
}
